import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  /**
   * Gets or sets if loader is shown.
   */
  @Input() isLoading: boolean = false;

  @Input() showProgress: boolean = false;

  @Input() color: string = 'white';

  @Input() variant: string = '--4';

  @Input() progress: number = 0;

  constructor() {}

  ngOnInit(): void {}
}
